import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormControlLabel, Radio } from '@mui/material';
import { Colors, FindLoad, FindSuccessItem, useGlobalTextStyles, useModal } from 'utils';
import { claimActions, httpRequestsOnSuccessActions } from 'store';
import { modalsStyle } from '../../../../components/modal/styles';
import { MinLoader } from 'components';
import { clearinghouseStatusEnums, clearinghouseStatusList } from '../constants';
import { RejectClaim } from './rejectClaim';


export const ChangeClaimGroupedStatus = ({ ids, afterSuccess }) => {
    const ACTION_TYPE = 'CHANGE_CLAIM_STATUS';
    const classes = modalsStyle();
    const globalText = useGlobalTextStyles();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const dispatch = useDispatch();
    const { open, close } = useModal();
    const [status, setStatus] = useState();
    const [error, setError] = useState(null);

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            if (afterSuccess) {
                afterSuccess();
            }
        }
    }, [success]);
    const changeReason = (e) => {
        setStatus(e.target.value);
        setError(null);
    };

    const handleSubmit = () => {
        const REJECTION_STATUSES = [clearinghouseStatusEnums.CH_REJECTED, clearinghouseStatusEnums.DENIED_BY_PAYER];

        if (status) {
            if (REJECTION_STATUSES.includes(status)) {
                open(<RejectClaim ids={ids} afterSuccess={afterSuccess} status={status} />);
            } else {
                dispatch(
                    claimActions.changeClaimStatus({
                        claimIds: ids,
                        clearinghouseStatus: status,
                    })
                );
            }
        } else {
            setError('status');
        }
    };

    return (
        <div className={classes.customDeleteModal}>
            <div>
                <p className={globalText.modalTitle}>{'Update Claim Status'}</p>
                <div className="reasons-wrapper" style={{ marginTop: 16 }}>
                    <p className="reason-for">{'Select new status for selected claims'}</p>
                    {clearinghouseStatusList?.map((i, j) => (
                        <FormControlLabel
                            key={j}
                            onChange={changeReason}
                            name="generateType"
                            value={i?.id}
                            label={
                                <span
                                    style={{
                                        color: error ? '#FE7070' : '#101828',
                                        fontWeight: status === i?.id ? 600 : 400,
                                    }}>
                                    {i?.name}
                                </span>
                            }
                            control={
                                <Radio
                                    style={{ color: error ? '#FE7070' : status === i?.id ? '#347AF0' : '#D0D5DD' }}
                                    checked={status === i?.id}
                                />
                            }
                        />
                    ))}
                </div>

                <div className={classes.buttons}>
                    <button className="close-btn-box" onClick={() => close()}>
                        Cancel
                    </button>
                    <button className={'confirm-btn'} onClick={handleSubmit}>
                        {loader?.length ? <MinLoader margin={'0'} color={Colors.TextWhite} /> : 'Update Status'}
                    </button>
                </div>
            </div>
        </div>
    );
};
